import request from '@/axios'
// import request from '@/utils/request'

export function Login (query) {
  //
  return request({
    url: '/auth/login',
    method: 'POST',
    data: query
  })
}

export function ForgotPassword (payload) {
  //
  return request({
    url: '/auth/forget_password',
    method: 'POST',
    data: payload
  })
}

export function getSubdomainExists(subdomainName) {
  return request({
    url: `/check_subdomain/${subdomainName}`,
    method: 'GET'
  })
}

export function reset_password (payload) {
  //
  return request({
    url: '/users/reset_password_internal',
    method: 'POST',
    data: payload
  })
}

export function fetch_accessible_module_list (customer_id) {
  return request({
    url: `/users/fetch_accessible_module_list/A/${customer_id}`,
    method: 'GET'
  })
}

export function new_fetch_accessible_module_list (customer_id) {
  return request({
    url: `V1/role/fetch_accessible_module_list/${customer_id}`,
    method: 'GET'
  })
}

export function ResetForgetPassword (payload) {
  //
  return request({
    url: '/auth/reset_password',
    method: 'POST',
    data: payload
  })
}

export function googleLogin (url) {
  return request({
    url,
    method: 'GET'
  })
}

export function changePasswordApi (payload) {
  return request({
    url: '/users/reset_password_internal',
    method: 'POST',
    data: payload
  })
}
